import React from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import './main.css';

import Diamond from './images/diamond.svg';
import Dots from './images/ Dots.svg';

function Section3(props) {
    AOS.init();
    return (
        <section className="australia-council-section3-container">
            <div className="ac-section3-paragraph1">
                <img src={Diamond} alt="" height="80px" className="ac-section3-image-diamond" />
                <div className="ac-section3-paragraph1-inner">
                    <div data-aos="fade-right" data-aos-delay="50" data-aos-duration="2000" data-aos-once="true"><h2 className="australia-council-section3-num">{props.info1Num}</h2></div>
                    <h3 data-aos="fade-down" data-aos-delay="100" data-aos-duration="2000" data-aos-once="true">{props.info1}</h3>
                </div>
                <img src={Diamond} alt="" height="80px" className="ac-section3-image-diamond2" />
            </div>
            <img src={Dots} alt="" height="100px" className="ac-section3-image-dot" />

            <div className="ac-section3-paragraph2">
                <div className="ac-section3-paragraph2-inner">
                    <div data-aos="fade-left" data-aos-delay="150" data-aos-duration="2000" data-aos-once="true" className="australia-council-section3-numCont"><h2 className="australia-council-section3-num">{props.info2Num}</h2></div>
                    <h3 data-aos="fade-down" data-aos-delay="200" data-aos-duration="2000" data-aos-once="true">{props.info2}</h3>
                </div>
            </div>
        </section>
    )
}

export default Section3
